import { orderXClient } from '@/service/client'
import type {
  DataPayload,
  OrderbookMetricsSeries,
  OrderbookMetricsSeriesRequest,
} from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

/**
 * Orderbook-metrics series pull endpoint (read-only, request/reply, no live
 * stream in v1 — poll on bar close). See
 * docs/orderbook-metrics-and-chart-families-frontend.md §1.
 */
export async function fetchOrderbookMetricsSeries(
  params: OrderbookMetricsSeriesRequest,
  signal?: AbortSignal
): Promise<OrderbookMetricsSeries> {
  try {
    const { data } = await orderXClient.post<DataPayload>(
      '/api',
      { orderbookMetricsSeries: params },
      { headers: { 'X-Decode-Key': 'datapayload' }, signal }
    )

    const series = data.orderbookMetricsSeries
    if (!series) {
      return Promise.reject({
        status: 400,
        message: 'Response did not include the orderbook_metrics_series payload.',
      } satisfies ErrorResponse)
    }
    return series
  } catch (e) {
    return Promise.reject(e as ErrorResponse)
  }
}
